import { useEffect, useState } from "react";

const LectureComp = ({ lecture, onClose }) => {
  const [videoLink, setVideoLink] = useState(lecture.videoLink);
  const [dimensions, setDimensions] = useState({ width: 900, height: 500 });

  const calculateDimensions = () => {
    const width = Math.min(window.innerWidth * 0.9, 900);
    const height = (width / 16) * 9;
    setDimensions({ width, height });
  };

  useEffect(() => {
    calculateDimensions();
    window.addEventListener("resize", calculateDimensions);
    return () => {
      window.removeEventListener("resize", calculateDimensions);
    };
  }, []);

  const videoUrl = `${videoLink}?modestbranding=1&amp;rel=0&controls=0&showinfo=1&autohide=1&iv_load_policy=3`;

  return (
    <div
      className="fixed inset-0 w-screen h-screen bg-white"
      style={{ zIndex: "1000" }}
    >
      <div
        className="relative w-full h-full flex flex-col bg-white"
        style={{ zIndex: "10000" }}
      >
        <button
          onClick={onClose}
          className="btn w-24 h-[5%] btn-sm text-white bg-pink-600 hover:bg-pink-700"
        >
          Go Back
        </button>

        <div className="flex-grow flex items-center justify-center">
          <iframe
            className="w-full h-full"
            src={videoUrl}
            width={dimensions.width}
            height={dimensions.height}
            title="Lecture Video"
            allow="clipboard-write;controls:0; encrypted-media; gyroscope; picture-in-picture"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default LectureComp;
